import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class AtendTopicoClassificadorService extends BaseService {
  constructor() {
    super(`${ConfigApi.atendTopicoClassificadorURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.descricao = '';

    this.resumo = '';
    this.limit = 9999;
    this.page = 0;
  }
}
export default new AtendTopicoClassificadorService();
